var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 8,
    viewBox: "0 0 59 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.8536 4.35355C59.0488 4.15829 59.0488 3.84171 58.8536 3.64645L55.6716 0.464466C55.4763 0.269204 55.1597 0.269204 54.9645 0.464466C54.7692 0.659728 54.7692 0.976311 54.9645 1.17157L57.7929 4L54.9645 6.82843C54.7692 7.02369 54.7692 7.34027 54.9645 7.53553C55.1597 7.7308 55.4763 7.7308 55.6716 7.53553L58.8536 4.35355ZM0 4.5L58.5 4.5V3.5L0 3.5L0 4.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.bd687dcd35da2b9e1ce9dbd6032cb623.svg";
export { ForwardRef as ReactComponent };